"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 24",
    width: "33",
    height: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.11,12.12v2.19H.92V12.12H3.11m.9-.9H0v4H4v-4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.8,12.12v2.19H7.61V12.12H9.8m.9-.9h-4v4h4v-4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.12,18.8V21H.93V18.8H3.12m.9-.9H0v4H4v-4Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "4.91",
    y: "11.21",
    width: "0.93",
    height: "0.93"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "4.91",
    y: "12.14",
    width: "0.93",
    height: "2.65"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.07",
    y: "16.58",
    width: "2.66",
    height: "0.9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "3.41",
    y: "16.58",
    width: "4.76",
    height: "0.9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "15.68",
    width: "1.9",
    height: "0.9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5.14",
    y: "18.82",
    width: "2.93",
    height: "0.9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.27",
    y: "19.47",
    width: "0.93",
    height: "4.01",
    transform: "translate(-12.74 30.21) rotate(-90)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.81",
    y: "18.82",
    width: "0.93",
    height: "3.11",
    transform: "translate(20.55 40.75) rotate(180)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6.7",
    y: "21.05",
    width: "0.93",
    height: "0.9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.8",
    y: "20.17",
    width: "0.93",
    height: "1.76"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.77,7.64V9.39H25V7.64h1.75m.75-.75H24.27v3.25h3.25V6.89Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.22,7.64V9.39H30.47V7.64h1.75M33,6.89H29.72v3.25H33V6.89Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.78,13.07v1.75H25V13.07h1.75m.75-.75H24.28v3.25h3.25V12.32Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "28.26",
    y: "6.88",
    width: "0.76",
    height: "0.76"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "28.26",
    y: "7.64",
    width: "0.76",
    height: "2.15"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "30.83",
    y: "11.25",
    width: "2.17",
    height: "0.73"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "27.04",
    y: "11.25",
    width: "3.87",
    height: "0.73"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "24.26",
    y: "10.52",
    width: "1.55",
    height: "0.73"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "28.45",
    y: "13.07",
    width: "2.38",
    height: "0.73"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "30.99",
    y: "13.6",
    width: "0.76",
    height: "3.26",
    transform: "translate(16.14 46.6) rotate(-90)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "32.24",
    y: "13.07",
    width: "0.76",
    height: "2.53",
    transform: "translate(65.24 28.68) rotate(180)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "29.71",
    y: "14.89",
    width: "0.76",
    height: "0.73"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "32.23",
    y: "14.17",
    width: "0.76",
    height: "1.43"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4,2.6V4H9V2.6H10.4M10.95,2H8.44V4.56h2.51V2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.6,2.6V4H13.19V2.6H14.6M15.15,2H12.64V4.56h2.51V2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.41,6.79V8.2H9V6.79h1.41M11,6.24H8.45V8.75H11V6.24Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.51",
    y: "2.05",
    width: "0.59",
    height: "0.59"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.51",
    y: "2.63",
    width: "0.59",
    height: "1.66"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "13.5",
    y: "5.42",
    width: "1.67",
    height: "0.57"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.57",
    y: "5.42",
    width: "2.99",
    height: "0.57"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.43",
    y: "4.85",
    width: "1.19",
    height: "0.57"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.66",
    y: "6.82",
    width: "1.84",
    height: "0.57"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "13.62",
    y: "7.23",
    width: "0.59",
    height: "2.52",
    transform: "translate(5.43 22.41) rotate(-90)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.59",
    y: "6.82",
    width: "0.59",
    height: "1.96",
    transform: "translate(29.76 15.6) rotate(180)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.64",
    y: "8.22",
    width: "0.59",
    height: "0.57"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.58",
    y: "7.67",
    width: "0.59",
    height: "1.11"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22,10.45a.5.5,0,0,1-.28-.08L16.59,7a.5.5,0,1,1,.55-.83l5.09,3.39a.5.5,0,0,1-.28.92Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.35,17.75a.5.5,0,0,1-.21-1L22.45,12a.5.5,0,0,1,.42.91L12.56,17.7A.49.49,0,0,1,12.35,17.75Z"
  }));
};

exports["default"] = _default;